(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accessible-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accessible-video')) {
    class AccessibleVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-accessible-video-toggle]');
        if (!this.video) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onReducedMotionChange = this.handleReducedMotionChange.bind(this);
        this.onToggle = this.handleToggle.bind(this);
        this.onPlay = this.syncControl.bind(this);
        this.onPause = this.syncControl.bind(this);

        this.applyReducedMotion(this.reducedMotion.matches);

        if (typeof this.reducedMotion.addEventListener === 'function') {
          this.reducedMotion.addEventListener('change', this.onReducedMotionChange);
        } else {
          this.reducedMotion.addListener(this.onReducedMotionChange);
        }

        if (this.toggle) {
          this.toggle.addEventListener('click', this.onToggle);
          this.video.addEventListener('play', this.onPlay);
          this.video.addEventListener('pause', this.onPause);
          this.syncControl();
        }
      }

      disconnectedCallback() {
        if (this.reducedMotion) {
          if (typeof this.reducedMotion.removeEventListener === 'function') {
            this.reducedMotion.removeEventListener(
              'change',
              this.onReducedMotionChange
            );
          } else {
            this.reducedMotion.removeListener(this.onReducedMotionChange);
          }
        }

        if (this.toggle) {
          this.toggle.removeEventListener('click', this.onToggle);
        }

        if (this.video) {
          this.video.removeEventListener('play', this.onPlay);
          this.video.removeEventListener('pause', this.onPause);
        }
      }

      handleReducedMotionChange(event) {
        this.applyReducedMotion(event.matches);
      }

      applyReducedMotion(matches) {
        if (matches) {
          this.pauseVideo();
          return;
        }

        if (this.hasAttribute('data-autoplay')) {
          this.playVideo();
        }
      }

      handleToggle(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.video.paused) {
          this.playVideo();
        } else {
          this.pauseVideo();
        }
      }

      playVideo() {
        const playPromise = this.video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      pauseVideo() {
        this.video.pause();
      }

      syncControl() {
        if (!this.toggle) return;

        const paused = this.video.paused;
        const pauseIcon = this.toggle.querySelector('[data-icon-pause]');
        const playIcon = this.toggle.querySelector('[data-icon-play]');
        const label = paused
          ? this.toggle.getAttribute('data-label-play')
          : this.toggle.getAttribute('data-label-pause');

        this.toggle.setAttribute('aria-label', label);

        if (pauseIcon) pauseIcon.hidden = paused;
        if (playIcon) playIcon.hidden = !paused;
      }
    }

    customElements.define('accessible-video', AccessibleVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
